import { useContext } from "react";
import { useEntity } from "./use-entity";
import { ActiveEntityContext } from "../components/context/active-entity-context";
/* allows a secondary Active Entity to be prov ided, which helps us render a partially active nav item */

export function useActiveEntity() {
  var entity = useEntity();
  var providedEntity = useContext(ActiveEntityContext);
  return providedEntity || entity;
}
;